// no image options, 2 columns – filters out disabled items

window.addEventListener('load', function () {
  const DisplayTemplateA = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    computed: {
      visibleItems() {
        return this.items || [];
      }
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6 display-template display-template-a">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full" style="grid-template-columns: repeat(2, minmax(0, 1fr));">
          <button
            v-for="item in visibleItems"
            :key="item.id"
            :data-option-key="item.optionKey"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold transition-all duration-200 ease-in-out transform rounded cursor-pointer"
            :style="{
              minWidth: '80px',
              padding: '0.75rem 1rem',
              borderRadius: '0.375rem',
              textAlign: 'center',
              display: 'inline-block',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid var(--xpv-primary-magenta)'
                : hovering === item.id && !item.disabled
                  ? '2px solid var(--xpv-primary-magenta-hover)'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <span class="xpv-option-tag"></span>
            <span class="xpv-option-label">{{ item.label }}</span>

            <div
              class="xpv-checkmark absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center z-50 transition-all duration-200"
              :style="{
                backgroundColor: selected === item.id ? 'var(--xpv-primary-magenta)' : 'white',
                border: selected === item.id ? '2px solid var(--xpv-primary-magenta)' : '2px solid #d1d5db'
              }"
            >
              <span v-if="selected === item.id" style="color: white">✓</span>
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-a'] = DisplayTemplateA;
});

// b

window.addEventListener('load', function () {
  const DisplayTemplateB = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="display-template display-template-b">
        <p class="text-gray-600 text-base mb-4">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-3 md:!grid-cols-4">
          <button
            v-for="item in items"
            :key="item.id"
            :data-option-key="item.optionKey"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="rounded relative cursor-pointer flex flex-col justify-start h-full transition-all duration-200"
            :style="{
              border: selected === item.id
                ? '2px solid var(--xpv-primary-magenta)'
                : hovering === item.id && !item.disabled
                  ? '2px solid var(--xpv-primary-magenta-hover)'
                  : '2px solid #d1d5db',
              backgroundColor: 'white',
              transform: selected === item.id ? 'scale(1.02)' : 'scale(1)',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <img :src="item.thumbnail" alt="" class="w-full aspect-square object-cover" />
            <div class="text-center py-2 text-sm xpv-option-label">{{ item.label }}</div>

            <div
              class="xpv-checkmark absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center z-50 transition-all duration-200"
              :style="{
                backgroundColor: selected === item.id ? 'var(--xpv-primary-magenta)' : 'white',
                border: selected === item.id ? '2px solid var(--xpv-primary-magenta)' : '2px solid #d1d5db'
              }"
            >
              <span v-if="selected === item.id" style="color: white">✓</span>
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-b'] = DisplayTemplateB;
});

// no image options, 3 columns

window.addEventListener('load', function () {
  const DisplayTemplateC = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6 display-template display-template-c">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-2 md:!grid-cols-3">
          <button
            v-for="item in items"
            :key="item.id"
            :data-option-key="item.optionKey"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold text-black transition-all duration-200 ease-in-out transform rounded cursor-pointer"
            :style="{
              minWidth: '80px',
              padding: '0.75rem 1rem',
              borderRadius: '0.375rem',
              textAlign: 'center',
              display: 'inline-block',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid var(--xpv-primary-magenta)'
                : hovering === item.id && !item.disabled
                  ? '2px solid var(--xpv-primary-magenta-hover)'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <span class="xpv-option-label">{{ item.label }}</span>

            <div
              class="xpv-checkmark absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center z-50 transition-all duration-200"
              :style="{
                backgroundColor: selected === item.id ? 'var(--xpv-primary-magenta)' : 'white',
                border: selected === item.id ? '2px solid var(--xpv-primary-magenta)' : '2px solid #d1d5db'
              }"
            >
              <span v-if="selected === item.id" style="color: white">✓</span>
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-c'] = DisplayTemplateC;
});

// fancy buttons image + description + price

window.addEventListener('load', function () {
  const DisplayTemplateD = {
    props: {
      label: String,
      value: [String, Number],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectItem(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6 display-template display-template-d">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div v-if="items?.length">
          <button
            v-for="item in items"
            :key="item.id"
            type="button"
            :data-option-key="item.optionKey"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectItem(item.id)"
            :disabled="item.disabled"
            class="cursor-pointer flex items-center rounded-lg p-4 transition relative mb-3 w-full text-left"
            :style="{
              border: selected === item.id
                ? '2px solid var(--xpv-primary-magenta)'
                : hovering === item.id && !item.disabled
                  ? '2px solid var(--xpv-primary-magenta-hover)'
                  : '2px solid #d1d5db',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <div class="xpv-option-tag-wrapper">
              <span class="xpv-option-tag"></span>
            </div>

            <img
              v-if="item.thumbnail"
              :src="item.thumbnail"
              alt=""
              class="w-20 h-20 object-cover rounded mr-4"
            >
            <div class="flex-1">
              <div class="text-base font-semibold xpv-option-label">{{ item.label }}</div>
              <div v-if="item.description" class="text-sm text-gray-500 leading-snug mt-1" v-html="item.description"></div>
            </div>
            <div v-if="item.price" class="text-lg font-semibold ml-4 whitespace-nowrap">
              € {{ item.price.toFixed(0) }}
            </div>

            <div
              class="xpv-checkmark absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center z-50 transition-all duration-200"
              :style="{
                backgroundColor: selected === item.id ? 'var(--xpv-primary-magenta)' : 'white',
                border: selected === item.id ? '2px solid var(--xpv-primary-magenta)' : '2px solid #d1d5db'
              }"
            >
              <span v-if="selected === item.id" style="color: white">✓</span>
            </div>
          </button>
        </div>
        <div v-else class="text-sm text-gray-400">No options available</div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-d'] = DisplayTemplateD;
});

// two-option toggle with styled card (No = items[0], Yes = items[1])

window.addEventListener('load', function () {
  const DisplayTemplateE = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: null,
        hovering: null
      };
    },
    methods: {
      updateSelection() {
        if (this.items.length > 0) {
          this.selected = this.value === this.items[1]?.id;
        }
      },
      toggleSelection() {
        if (!this.items[1]?.disabled) {
          this.selected = !this.selected;
        }
      }
    },
    template: `
      <div class="mb-6 display-template display-template-e">
        <div v-if="items?.length > 1">
          <button
            type="button"
            :data-option-key="items[1].optionKey"
            @mouseenter="!items[1].disabled && (hovering = true)"
            @mouseleave="hovering = null"
            @click="toggleSelection"
            :disabled="items[1].disabled"
            class="cursor-pointer flex items-center rounded-lg p-4 transition relative w-full text-left"
            :style="{
              border: selected
                ? '2px solid var(--xpv-primary-magenta)'
                : hovering && !items[1].disabled
                  ? '2px solid var(--xpv-primary-magenta-hover)'
                  : '2px solid #d1d5db',
              backgroundColor: selected ? '#F8F8FA' : 'white',
              opacity: items[1].disabled ? 0.4 : 1,
              cursor: items[1].disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <img
              v-if="items[1].thumbnail"
              :src="items[1].thumbnail"
              alt=""
              class="w-20 h-20 object-cover rounded mr-4"
            >
            <div class="flex-1">
              <div class="text-base font-semibold xpv-option-label">{{ label }}</div>
              <div v-if="items[1].description" class="text-sm text-gray-500 leading-snug mt-1" v-html="items[1].description"></div>
            </div>
            <div v-if="items[1].price" class="text-lg font-semibold ml-4 whitespace-nowrap">
              € {{ items[1].price.toFixed(0) }}
            </div>

            <div
              class="xpv-checkmark absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center z-50 transition-all duration-200"
              :style="{
                backgroundColor: selected ? 'var(--xpv-primary-magenta)' : 'white',
                border: selected ? '2px solid var(--xpv-primary-magenta)' : '2px solid #d1d5db'
              }"
            >
              <span v-if="selected" style="color: white">✓</span>
            </div>
          </button>
        </div>
        <div v-else class="text-sm text-gray-400">No options available</div>
      </div>
    `,
    watch: {
      value() {
        this.updateSelection();
      },
      selected(newValue) {
        if (newValue) {
          this.$emit('input', this.items[1].id);
        } else {
          this.$emit('input', this.items[0].id);
        }
      }
    },
    mounted() {
      this.updateSelection();
    }
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-e'] = DisplayTemplateE;
});

// deselectable pill-style options with fallback to "None" (items[0]), but "None" is hidden

window.addEventListener('load', function () {
  const DisplayTemplateF = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        if (newVal === null || newVal === undefined) {
          this.$emit('input', this.items[0]?.id);
        } else {
          this.$emit('input', newVal);
        }
      }
    },
    methods: {
      toggleOption(id) {
        this.selected = this.selected === id ? null : id;
      }
    },
    template: `
      <div class="mb-6 display-template display-template-f">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-2">
          <button
            v-for="item in items.slice(1)"
            :key="item.id"
            :data-option-key="item.optionKey"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && toggleOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold text-black transition-all duration-200 ease-in-out transform rounded cursor-pointer"
            :style="{
              minWidth: '80px',
              padding: '0.75rem 1rem',
              borderRadius: '0.375rem',
              textAlign: 'center',
              display: 'inline-block',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid var(--xpv-primary-magenta)'
                : hovering === item.id && !item.disabled
                  ? '2px solid var(--xpv-primary-magenta-hover)'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <span class="xpv-option-label">{{ item.label }}</span>

            <div
              class="xpv-checkmark absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center z-50 transition-all duration-200"
              :style="{
                backgroundColor: selected === item.id ? 'var(--xpv-primary-magenta)' : 'white',
                border: selected === item.id ? '2px solid var(--xpv-primary-magenta)' : '2px solid #d1d5db'
              }"
            >
              <span v-if="selected === item.id" style="color: white">✓</span>
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-f'] = DisplayTemplateF;
});

// 2 columns with image

window.addEventListener('load', function () {
  const DisplayTemplateG = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6 display-template display-template-g">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="grid gap-3 w-full grid-cols-2">
          <button
            v-for="item in items"
            :key="item.id"
            :data-option-key="item.optionKey"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectOption(item.id)"
            :disabled="item.disabled"
            class="relative text-base font-semibold transition-all duration-200 ease-in-out transform rounded cursor-pointer flex flex-col items-center"
            :style="{
              padding: '0',
              borderRadius: '0.375rem',
              backgroundColor: selected === item.id ? '#F8F8FA' : 'white',
              border: selected === item.id
                ? '2px solid var(--xpv-primary-magenta)'
                : hovering === item.id && !item.disabled
                  ? '2px solid var(--xpv-primary-magenta-hover)'
                  : '2px solid #d1d5db',
              color: item.disabled ? '#aaa' : '#000',
              opacity: item.disabled ? 0.4 : 1,
              cursor: item.disabled ? 'not-allowed' : 'pointer'
            }"
          >
            <img
              v-if="item.thumbnail"
              :src="item.thumbnail"
              alt=""
              style="width: 100%; border-radius: 4px 4px 0 0; display: block;"
            />
            <div class="text-center xpv-option-label" style="padding: 0.5rem;">{{ item.label }}</div>

            <div
              class="xpv-checkmark absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center z-50 transition-all duration-200"
              :style="{
                backgroundColor: selected === item.id ? 'var(--xpv-primary-magenta)' : 'white',
                border: selected === item.id ? '2px solid var(--xpv-primary-magenta)' : '2px solid #d1d5db'
              }"
            >
              <span v-if="selected === item.id" style="color: white">✓</span>
            </div>
          </button>
        </div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-g'] = DisplayTemplateG;
});

window.addEventListener('load', function () {
  const DisplayTemplateH = {
    props: {
      label: String,
      value: [String, Number, null],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    computed: {
      selectedItem() {
        return this.items.find(item => item.id === this.selected) || null;
      }
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectOption(id) {
        this.selected = id;
      },
      scrollLeft() {
        this.$refs.wrapper.scrollBy({ left: -150, behavior: 'smooth' });
      },
      scrollRight() {
        this.$refs.wrapper.scrollBy({ left: 150, behavior: 'smooth' });
      }
    },
    template: `
      <div class="mb-6 display-template display-template-h">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div class="xpv-h-slider">
          <button type="button" class="xpv-h-arrow xpv-h-arrow--prev" @click="scrollLeft">
            <svg viewBox="0 0 24 24" style="width:18px;height:18px;">
              <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"></path>
            </svg>
          </button>
          <div class="xpv-h-slider__wrapper" ref="wrapper">
            <div class="xpv-h-slider__content">
              <button
                v-for="item in items"
                :key="item.id"
                type="button"
                :data-option-key="item.optionKey"
                @mouseenter="!item.disabled && (hovering = item.id)"
                @mouseleave="hovering = null"
                @click="!item.disabled && selectOption(item.id)"
                :disabled="item.disabled"
                class="xpv-h-option"
                :class="{ 'xpv-h-option--active': selected === item.id, 'xpv-h-option--disabled': item.disabled }"
              >
                <span class="xpv-option-label">{{ item.label }}</span>
              </button>
            </div>
          </div>
          <button type="button" class="xpv-h-arrow xpv-h-arrow--next" @click="scrollRight">
            <svg viewBox="0 0 24 24" style="width:18px;height:18px;">
              <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
            </svg>
          </button>
        </div>
        <transition name="xpv-h-desc">
          <div
            v-if="selectedItem && selectedItem.description"
            class="xpv-h-description"
            v-html="selectedItem.description"
          ></div>
        </transition>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-h'] = DisplayTemplateH;
});

window.addEventListener('load', function () {
  const DisplayTemplateI = {
    props: {
      label: String,
      value: [String, Number],
      items: Array,
      loading: Boolean,
      size: String,
      rounded: String,
      node_id: Number
    },
    data() {
      return {
        selected: this.value,
        hovering: null
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      },
      selected(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      selectItem(id) {
        this.selected = id;
      }
    },
    template: `
      <div class="mb-6 display-template display-template-i">
        <p class="text-gray-600 text-base mb-2">{{ label }}</p>
        <div v-if="items?.length">
          <button
            v-for="item in items"
            :key="item.id"
            type="button"
            :data-option-key="item.optionKey"
            @mouseenter="!item.disabled && (hovering = item.id)"
            @mouseleave="hovering = null"
            @click="!item.disabled && selectItem(item.id)"
            :disabled="item.disabled"
            class="xpv-i-option"
            :class="{ 'xpv-i-option--selected': selected === item.id, 'xpv-i-option--disabled': item.disabled, 'xpv-i-option--hover': hovering === item.id && !item.disabled }"
          >
            <div class="xpv-i-radio">
              <div class="xpv-i-radio__dot"></div>
            </div>
            <span class="xpv-i-label">{{ item.label }}</span>
            <div v-if="item.description" class="xpv-i-description" v-html="item.description"></div>
            <div v-if="item.price" class="xpv-i-price">€ {{ item.price.toFixed(0) }}</div>
          </button>
        </div>
        <div v-else class="text-sm text-gray-400">No options available</div>
      </div>
    `
  };

  ExpiviOptionsVueInstance.prototype.$customViews['display-template-i'] = DisplayTemplateI;
});

// --- Footer Prev/Next ---
window.addEventListener('load', function () {
  const FooterNav = {
    data() {
      return {
        currentIndex: 0,
        total: 0,
        locale: 'de',
        _observer: null
      };
    },
    computed: {
      isFirst() { return this.currentIndex <= 0; },
      isLast()  { return this.currentIndex >= Math.max(0, this.total - 1); },
      t() {
        const isEN = this.locale.startsWith('en');
        return {
          previous: isEN ? 'Previous step' : 'Zurück',
          next: isEN ? 'Next step' : 'Weiter',
          finished: isEN ? 'Finished' : 'Fertig'
        };
      }
    },
    template: `
      <div class="moona-footer-nav flex items-center gap-3 mt-4 display-template custom-footer">
        <button
          v-if="!isFirst"
          type="button"
          @click="prev"
          class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border border-gray-300 hover:bg-gray-50 transition"
        >
          <svg viewBox="0 0 24 24" style="width:18px;height:18px;">
            <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"></path>
          </svg>
          {{ t.previous }}
        </button>

        <div class="flex-1"></div>

        <button
          v-if="!isLast"
          type="button"
          @click="next"
          class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border border-pink-600 text-pink-700 hover:bg-pink-50 transition"
        >
          {{ t.next }}
          <svg viewBox="0 0 24 24" style="width:18px;height:18px;">
            <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
          </svg>
        </button>

        <button
          v-else
          id="moona-finish-btn"
          type="button"
          @click="finished"
          class="px-4 py-2 rounded-lg text-sm font-semibold bg-emerald-600 hover:bg-emerald-700 transition"
        >
          {{ t.finished }}
        </button>
      </div>
    `,
    methods: {
      _buttons() {
        return Array.from(document.querySelectorAll('.v-slide-group__content .v-btn'));
      },
      _activeButton() {
        return document.querySelector('.v-slide-group__content .v-btn.v-slide-item--active');
      },
      _go(btn) {
        if (!btn) return;
        btn.click();
        try { btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (_) {}
        setTimeout(this._updateState, 0);
      },
      next() {
        const list = this._buttons();
        const idx  = this.currentIndex;
        if (idx > -1 && idx < list.length - 1) this._go(list[idx + 1]);
      },
      prev() {
        const list = this._buttons();
        const idx  = this.currentIndex;
        if (idx > 0) this._go(list[idx - 1]);
      },
      finished() {
        const ev = new CustomEvent('moona:finished');
        window.dispatchEvent(ev);
      },
      _updateState() {
        const list  = this._buttons();
        const active = this._activeButton();
        const idx = list.indexOf(active);
        this.currentIndex = Math.max(0, idx);
        this.total = list.length;
      },
      _initObserver() {
        const content = document.querySelector('.v-slide-group__content');
        if (!content) { this._updateState(); return; }
        this._updateState();
        this._observer = new MutationObserver(() => this._updateState());
        this._observer.observe(content, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      },
      _detectLocale() {
        const urlParams = new URLSearchParams(window.location.search);
        const loc = (urlParams.get('locale') || '').toLowerCase();
        this.locale = loc || 'de';
      }
    },
    mounted() {
      this._detectLocale();
      this._initObserver();
      try {
        window.expivi?._events?.onChange?.subscribe?.(() => this._updateState());
      } catch(_) {}
      this._poll = setInterval(this._updateState, 800);
    },
    beforeDestroy() {
      if (this._observer) this._observer.disconnect();
      if (this._poll) clearInterval(this._poll);
    }
  };

  ExpiviOptionsVueInstance.prototype.$customViews['custom-footer'] = FooterNav;
});